import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { UndoButton, DBTextArea } from '_components';
import { getGoalSentenceFunc } from '_helpers';
import styles from './Common.module.css';
import { GoalDropDown } from './GoalDropDown';

class PatientCareCenterNoteGoalsGoalDetailsFuncDelete extends React.Component {
    loaTriggers = [2, 7, 8];
    goalValueChanged() {
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }

    undoDeleteGoal() {
        this.props.updateBitField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GODELETED', false);
        if (this.props.goal.GODELREASON) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GODELREASON');
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            this.props.goal.GOMINMODMAX &&
            !this.loaTriggers.includes(this.props.goal.GOLONO)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOMINMODMAX');
        }
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            prevProps.goal.GOGOALLEVEL &&
            !Object.keys(this.props.goalLevels).map(key => { return this.props.goalLevels[key].id }).includes(prevProps.goal.GOGOALLEVEL)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOGOALLEVEL');
        }
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            prevProps.goal.GOPLOF &&
            !Object.keys(this.props.goalLevels).map(key => { return this.props.goalLevels[key].id }).includes(prevProps.goal.GOPLOF)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOPLOF');
        }
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            prevProps.goal.GOCLOF &&
            !Object.keys(this.props.clofGoalLevels).map(key => { return this.props.clofGoalLevels[key].id }).includes(prevProps.goal.GOCLOF)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOCLOF');
        }
    }

    render() {
        return (
            <div className={styles.goal_detail_wrapper}>
                <div className={styles.goal_detail_row}>
                    <span className={styles.goal_detail_label_req}>Activity:</span>
                    <span className={styles.goal_detail_activity}>
                        <GoalDropDown
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.goal.GONO}
                            isFunctional={true}
                            className={styles.goal_dropdown}
                        />
                    </span>

                    <span>
                        <span className={styles.goal_detail_fav} />
                        <span className={styles.goal_detail_delete}>
                            <UndoButton title='Undo Delete' size='extra-small' onClick={() => this.undoDeleteGoal()} />
                        </span>
                    </span>
                </div>

                <div className={styles.goal_detail_row}>
                    <span className={styles.goal_detail_label}>Goal:</span>
                </div>

                <div className={styles.goal_detail_row}>
                    <span className={styles.goal_sentence}>{getGoalSentenceFunc(this.props.activityName, this.props.goalLevelSentence, this.props.goal, this.props.loa)}</span>
                </div>

                <span>
                    <div className={styles.goal_detail_row}>
                        <span className={styles.goal_detail_label_req_top}>Reason:</span>
                        <span className={styles.goal_input}>
                            <DBTextArea
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GODELREASON'
                                className={styles.text_area}
                                onChange={() => this.goalValueChanged()}
                                rows={6}
                            />
                        </span>
                    </div>
                </span>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let activityName = goal.GOMGNO ? state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '';
    let goalLevelSentence = goal.GOGOALLEVEL ? state.entities.masterData.PTMASTERGOALLEVELS[goal.GOGOALLEVEL].GLSENTENCETXT : '';
    let loa = goal.GOLONO ? state.entities.masterData.PTMASTERGOALLOA[goal.GOLONO].LOSENTENCETXT : '';
    let goalsUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTGOALSUPDATED : true;

    let clofGoalLevels = [];
    if (goal.GOMGNO) {
        // get based on XREF
        let glnos = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
            .filter(key => {
                return (state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO);
            })
            .map(key => state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO);

        clofGoalLevels = Object.keys(state.entities.masterData.PTMASTERGOALLEVELS)
            .filter(key => {
                return (glnos.includes(state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO));
            })
            .sort((a, b) => {
                let aKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                    .find(key => {
                        return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                            state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[a].GLNO
                    });
                let aOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[aKey].GLXORDER;

                let bKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                    .find(key => {
                        return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                            state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[b].GLNO
                    });
                let bOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[bKey].GLXORDER;

                return aOrder - bOrder;
            })
            .map(key => {
                return {
                    id: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO,
                    value: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNAME,
                    sentence: state.entities.masterData.PTMASTERGOALLEVELS[key].GLSENTENCETXT,
                    clofOnly: state.entities.masterData.PTMASTERGOALLEVELS[key].GLCLOFONLY,
                }
            })
    } else if (goal.GOCUSTOM) {
        // get goal levels flagged as custom
        clofGoalLevels = Object.keys(state.entities.masterData.PTMASTERGOALLEVELS)
            .filter(key => {
                return (state.entities.masterData.PTMASTERGOALLEVELS[key].GLCUSTOM === true);
            })
            .sort((a, b) => {
                return state.entities.masterData.PTMASTERGOALLEVELS[a].GLCUSTOMORDER - state.entities.masterData.PTMASTERGOALLEVELS[b].GLCUSTOMORDER;
            })
            .map(key => {
                return {
                    id: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO,
                    value: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNAME,
                    sentence: state.entities.masterData.PTMASTERGOALLEVELS[key].GLSENTENCETXT,
                    clofOnly: state.entities.masterData.PTMASTERGOALLEVELS[key].GLCLOFONLY,
                }
            });
    }

    let goalLevels = Object.keys(clofGoalLevels)
        .filter(key => {
            return clofGoalLevels[key].clofOnly === false;
        })
        .map(key => {
            return clofGoalLevels[key];
        });

    let loaOptions = Object.keys(state.entities.masterData.PTMASTERGOALLOA)
        .filter(key => {
            return state.entities.masterData.PTMASTERGOALLOA[key].LOISGENERAL;
        })
        .sort((a, b) => {
            return state.entities.masterData.PTMASTERGOALLOA[a].LOORDER - state.entities.masterData.PTMASTERGOALLOA[b].LOORDER;
        })
        .map(key => {
            return {
                id: state.entities.masterData.PTMASTERGOALLOA[key].LONO,
                value: state.entities.masterData.PTMASTERGOALLOA[key].LONAME,
            }
        })

    let savePanelVisible = state.ui.notes[noteId].saveGoalFavoriteVisible;
    let goalFavorites = Object.keys(state.entities.notes.PTGOALFAVORITES)
        .filter(key => {
            return (noteType === 1 && state.entities.notes.PTGOALFAVORITES[key].GFEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALFAVORITES[key].GFNTNO === pk)
        })
        .sort((a, b) => state.entities.notes.PTGOALFAVORITES[a].GFNAME.localeCompare(state.entities.notes.PTGOALFAVORITES[b].GFNAME))
        .map(key => state.entities.notes.PTGOALFAVORITES[key]);

    let clofPrev = goal.GOCLOFPREV ? state.entities.masterData.PTMASTERGOALLEVELS[goal.GOCLOFPREV].GLNAME : undefined;
    let progressPrev = goal.GOGPNOPREV ? state.entities.masterData.PTMASTERGOALPROGRESS[goal.GOGPNOPREV].GPNAME : undefined;

    return {
        noteId: noteId,
        noteType,
        pk,
        goal: goal,
        activityName: activityName,
        goalLevelSentence: goalLevelSentence,
        loa: loa,
        clofGoalLevels: clofGoalLevels,
        goalLevels: goalLevels,
        loaOptions: loaOptions,
        savePanelVisible: savePanelVisible,
        goalFavorites: goalFavorites,
        goalsUpdated,
        clofPrev,
        progressPrev,
    };
}

const connectedPatientCareCenterNoteGoalsGoalDetailsFuncDelete = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsGoalDetailsFuncDelete);
export { connectedPatientCareCenterNoteGoalsGoalDetailsFuncDelete as PatientCareCenterNoteGoalsGoalDetailsFuncDelete };

